<!-- eslint-disable no-new -->
<script setup lang="ts">
  import { Modal } from 'bootstrap'
  import IconComponent from '../../../components/Atoms/Icon.vue'
  import sendClarityEvent from '@/utils/sendClarityEvent'

  import { ref, onMounted } from 'vue'
  import { useAR } from '@/store/Pinia/useAR.store'

  const { getLinkEmissor } = useAR()

  const modal = ref<InstanceType<typeof Modal> | null>(null)

  onMounted(() => {
    modal.value = new Modal('#modal-java', {
      backdrop: 'static',
      keyboard: false,
    })
  })

  function show() {
    modal.value?.show()
  }

  function hide() {
    modal.value?.hide()
  }

  function sendEvent() {
    sendClarityEvent('downloadJavaIssuer')
  }

  defineExpose({ show, hide })
</script>

<template>
  <div id="modal-java" class="modal modal-md fade" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header pb-3">
          <button
            class="btn-close"
            type="button"
            data-bs-dismiss="modal"
            aria-label="Close"
          />
        </div>
        <div class="modal-body py-3">
          <h5 class="modal-title mb-4">
            Veja como instalar o Certificado Digital em seu computador
          </h5>

          <div class="java-info-card row">
            <div class="col-2">
              <img src="../assets/java-blue.svg" alt="java" />
            </div>
            <div class="col-10 text-start">
              <p class="fs-6 mb-0">
                Antes de fazer o download do emissor, você precisa ter o Java
                instalado e atualizado em seu computador.
              </p>
              <a
                href="https://www.java.com/pt-BR/download/"
                target="_blank"
                class="fs-6 mb-0 link"
              >
                <span class="me-2">Clique aqui para fazer o download</span>
                <icon-component class="mt-2" name="download" />
              </a>
            </div>
          </div>

          <p class="fs-6 fw-bold text-start mt-4">
            Após o download, siga os passos até a conclusão da instalação.
          </p>

          <div class="d-flex gap-2 align-items-start">
            <icon-component class="green pt-1" name="circle-check" />
            <div class="text-start">
              <p class="fs-6">
                Tenha em mãos seu <strong>usuário*</strong> e a
                <strong>senha de emissão</strong> do seu Certificado Digital.
              </p>
              <p class="fs-6 mt-2">
                *Você pode encontrar seu código de usuário em seu e-mail com o
                texto: “Emissão de Certificado Digital APROVADA” no assunto.
              </p>
            </div>
          </div>

          <a
            href="https://emissao-online-hom.soluti.com.br/ManualEmissaoA1.pdf"
            target="_blank"
            class="btn btn-sm btn-outline-primary mt-3"
          >
            <icon-component class="me-2" name="up-right-from-square" />
            Guia de instalação do Java
          </a>
        </div>
        <div class="modal-footer">
          <a
            :href="getLinkEmissor"
            target="_blank"
            class="btn btn-primary"
            @click="sendEvent"
          >
            <icon-component class="me-2" name="download" />
            <span>Baixar emissor</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .java-info-card {
    padding: 16px;
    background: #e6e7ec;
    border-radius: 10px;
  }

  .link {
    font-size: 1rem;
    font-weight: 400;
    color: #0080a3;
    cursor: pointer;
  }

  .green {
    color: #98dd63;
  }

  .btn-outline-primary:focus {
    color: var(--color-primary);
  }

  .btn-primary:focus {
    color: #fff;
  }

  @media (min-width: 576px) {
    .modal-md {
      --bs-modal-width: 624px;
    }
  }
</style>
